import View from 'mixins/view';
import moment from 'moment/moment';

const elements = {
  container: '.notification__text',
};

export default class ArticlesNotificationView extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(`<li class="notifications-list__item"></li>`));
  }
  buildImage(img) {
    return $(`
      <figure class="notification__media rmpl-flex-container rmpl-flex-justified">
          <img src="${img}" alt="" />
      </figure>
    `);
  }
  render() {
    moment.locale('pl');
    const model = this.model;
    const createdAt = model.get('createdAt');
    const momentCreatedAt = moment(createdAt);

    this.rootEl.html(`
        <a href="${model.get('url')}" ${ (model.get('newWindow')) ? "target='_blank'": '' }>
            <div class="rmpl-flex-container rmpl-flex-aligned notification__text">
                <div class="nt-meta">
                    <time class="nt-meta-time" datetime="${createdAt}">${momentCreatedAt.fromNow()}</time>
                </div>
                <div class="nt-header">${model.get('title')}</div>
            </div>
        </a>
    `);

    const img = model.get('photo') ? model.get('photo') : '/img/news-placeholder.png';
    this.rootEl.find('a').prepend(this.buildImage(img));
  }
}



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/mixins/notification-view.js